<template>
  <v-app :style="containerStyle">
    <v-main>
      <notification-banner></notification-banner>
      <v-container fluid fill-height>
        <v-col>
          <router-view>
            <v-img
              slot="logo"
              contain
              :src="require('@/assets/logo.png')"
              max-height="58"
              max-width="300"
            ></v-img>
          </router-view>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getPublicImageURL } from '@/firebaseConfig'
import NotificationBanner from '@/components/NotificationBanner.vue'

export default {
  name: 'AuthContainer',
  components: {
    NotificationBanner
  },
  data: () => ({
    loading: false
  }),
  created() {
    this.loadData()
  },
  computed: {
    subdomain() {
      if (location.host.split('.').length > 2) {
        return location.host.split('.')[0]
      }
      return undefined
    },
    logoSRC() {
      if (this.subdomain) {
        return getPublicImageURL(this.subdomain, 'logo.png')
      }

      return require('@/assets/logo.png')
    },
    containerStyle() {
      if (this.subdomain) {
        // has subdomain
        return {
          backgroundImage: `url('${getPublicImageURL(
            this.subdomain,
            'backgroundTile.png'
          )}')`
        }
      }
      return null
    }
  },
  methods: {
    loadData() {
      this.loading = true
    }
  }
}
</script>

<style lang="sass" scoped>
#app
  background: $secondary
  background-repeat: repeat
</style>
